import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";
import ProductAutoComplete from "../../SalesPurchase/Components/ProductAutoComplete";

export default function ProductIngredients() {
  const ProductIngredientList = useSelector((state) => state.Inventory.Ingredients);
  const [showModal, setShowmodal] = useState(false);
  const [ProductIngredient, setProductIngredient] = useState([]);
  const [btnDisable, SetbtnDisable] = useState(false);
  const [modalName, setModalName] = useState("");
  const [formError, setFormError] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [ProductList, setProductList] = useState([]);
  const [filterText, setFilterText] = useState("");
  useEffect(() => {
    fetchHandler();
    fetchProduct()
  }, []);
  const handleModalClose = () => {
    setShowmodal(false);
  };
  const handleModalOpen = (e, id) => {
    setModalName(e);
      setProductIngredient("");
    setShowmodal(true);
    if (id) {
      fetchHandler(id);
    }
  };

  const fetchProduct = async () => {
      ApiConnect.get(`/Module/Inventory/Product/Details`)
      .then((response) => {
          setProductList(response.data);
      })
      .catch((error) => {})
  }


  const submitHandler = (e, type) => {
    e.preventDefault();
    SetbtnDisable(true);
    let formData = new FormData();
    formData.append("product_id", ProductIngredient["product_id"]);
    formData.append("ingredient", ProductIngredient["ingredient"]);
    formData.append("life_days", ProductIngredient["life_days"]);
    ApiConnect({
      method: "post",
      url: `/Module/Inventory/Product/${type}Ingredient`,
      data: formData,
    })
      .then((response) => {
        SetbtnDisable(false);
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          setProductIngredient([]);
          handleModalClose();
          fetchHandler();
        } else {
          setFormError(response.data.message);
        }
      })
      .catch((error) => console.log(error));
  };
  const dispatch = useDispatch();
  const columns = [
      {
          name: "Product Name",
          selector: row => row.name,
          sortable: true,
      },
    {
      name: "Product Id",
      selector: row => row.product_id,
      sortable: true,
    },
    {
      name: "Product Ingredients",
      selector: row => row.ingredient,
      sortable: true,
    },
      {
          name: "Life",
          selector: row => row.life_days,
          sortable: true,
      },
    {
      name: "Action",
      selector: row => row.action,
      className: "table-actions",
      width: "150px",
      sortable: false,
      cell: (row) => {
        return (
          <React.Fragment>
            <button
              className="table-action btn btn-square btn-pure hover-warning"
              onClick={() => handleModalOpen("Edit", row.product_id)}
            >
              <span className="material-icons-outlined">edit_note</span>
            </button>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(row.product_id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = ProductIngredientList.filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  const fetchHandler = (id = false) => {
    ApiConnect.get(`/Module/Inventory/Product/ingredient?id=${id ? id : ""}`)
      .then((response) => {
        if (id) {
          setProductIngredient(response.data[1]);
        } else {
          let Ingredient = response.data;
          dispatch({ type: "SET_INVENTORY_PRODUCT_INGREDIENT", payload: { Ingredient } });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange=(e)=>{
      let data = { ...ProductIngredient };
      if(!e.target){
          data["product_id"] = e.id;
      }
      else{
          const {name, value} = e.target;
          data[name] = value;
      }
      setProductIngredient(data);
  }
  console.log(ProductIngredient)
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>Product Ingredients</strong>
              <small className="subtitle">
                Here you can edit,delete,view Product Ingredients.
              </small>
            </h2>
          </div>
          <div className="right gap-items-2">
            <button
              className="btn btn-primary  btn-float btn-round"
              onClick={(e) => handleModalOpen("New")}
            >
              <span className="material-icons-outlined">add</span>
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="col-md-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="dataTables_wrapper">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={e => setFilterText(e.target.value)}
                  />
                </div>
                <DataTable
                  className="table table-separated"
                  keyField="id"
                  columns={columns}
                  data={filteredData}
                  pagination
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  paginationPerPage={10}
                  customStyles={customStyles}
                  filter
                  exportable
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        className="modal-center"
        onHide={(e) => handleModalClose()}
      >
        <Modal.Dialog>
          <Modal.Header>
            <h5 className="modal-title">{modalName} ProductIngredient</h5>
            <button
              type="button"
              className="btn"
              onClick={(e) => handleModalClose()}
            >
              <span>×</span>
            </button>
          </Modal.Header>
          <form onSubmit={(e) => submitHandler(e, modalName.toLocaleLowerCase())}>
            <Modal.Body>
              <p className="text-danger">{formError}</p>
              <label className="form-label">Product Name</label>
              <label className="col-12">
                  {ProductList.length>0 ?  <ProductAutoComplete
                      action={handleChange}
                      name="product_id"
                      value={ProductIngredient["product_id"]}
                      placeHolder="Scan / search products by code / name"
                      items={ProductList}
                  />:""}

                  
              </label>
                <label className="form-label">Life</label>
                <label className="col-12">
                    <input
                        type="number"
                        value={ProductIngredient["life_days"]}
                        className="form-control"
                        name="life_days"
                        required="required"
                        onChange={(e) => handleChange(e)}
                    />
                </label>
                <label className="form-label">Ingredient</label>
                <label className="col-12">
                    <textarea
                        type="text"
                        value={ProductIngredient["ingredient"]}
                        className="form-control"
                        name="ingredient"
                        required="required"
                        onChange={(e) => handleChange(e)}
                    />
                </label>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="submit"
                className="btn btn-success"
                disabled={btnDisable}
              >
                {modalName === "New" ? "Save" : "Edit"}
              </button>
            </Modal.Footer>
          </form>
        </Modal.Dialog>
      </Modal>
      <DeletePop
        trigger={triggerModal}
        delUrl={`/Module/Inventory/Product/deleteIngredient?id=${selectedId}`}
        hideTrigger={SettriggerModal}
        fallAction={fetchHandler}
      />
    </div>
  );
}
